import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import JsonExcel from 'vue-json-excel'

// 引入现代化主题样式
import './assets/css/theme.css'
import './assets/css/global.css'

// 引入全局错误处理
import { setupErrorHandler } from './utils/errorHandler'

// 引入图片URL修复工具
import { fixImageUrl } from './config/api'

Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

Vue.use(ElementUI, {size: "small"});

// 设置全局错误处理
setupErrorHandler(Vue);

// 注册全局过滤器：修复图片URL
Vue.filter('fixImageUrl', function(url) {
  return fixImageUrl(url);
});

// 注册全局方法：修复图片URL
Vue.prototype.$fixImageUrl = fixImageUrl;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
